import {
  incomingInviteMeta,
  incomingJoinedSentence,
  INVITE_MISSING,
  type IncomingDecision,
  type IncomingInvite,
  type IncomingOutcome,
} from "@/features/access/mock-plan-access";

export type InboxScope = "all" | "here";

/** 받은 함은 사용자 단위다. 워크스페이스는 줄을 좁히는 범위다. */
export function inviteInScope(invite: IncomingInvite, scope: InboxScope, workspaceName: string): boolean {
  if (scope === "all") return true;
  return invite.workspaceName === workspaceName;
}

/** 휴지통에 들어간 대상은 더 이상 수락할 수 없다. 없는 워크스페이스 초대는 아직 합류 전이라 그대로 둔다. */
export function inviteTargetMissing(
  invite: IncomingInvite,
  planTrashNames: readonly string[],
  workspaceTrashNames: readonly string[],
): boolean {
  if (invite.scope === "workspace") return workspaceTrashNames.includes(invite.workspaceName);
  return planTrashNames.includes(invite.planName);
}

export type InboxItem = {
  id: string;
  author: string;
  subject: string;
  preview: string;
  unread: boolean;
  missing: boolean;
  outcome: IncomingOutcome | null;
  invite: IncomingInvite;
};

export function inviteSubject(invite: IncomingInvite): string {
  if (invite.scope === "workspace") return `${invite.role}로 초대`;
  return invite.planName;
}

export function invitePreview(invite: IncomingInvite, missing: boolean, outcome: IncomingOutcome | null): string {
  if (missing) return INVITE_MISSING;
  if (outcome === "거절") return "거절함";
  if (outcome === "수락") return incomingJoinedSentence(invite);
  return incomingInviteMeta(invite);
}

/** 대기 초대가 먼저, 수락·거절이 뒤다. 지금은 초대만 있다. */
export function buildInboxItems(
  incoming: readonly IncomingInvite[],
  decisions: readonly IncomingDecision[],
  planTrashNames: readonly string[],
  workspaceTrashNames: readonly string[],
): InboxItem[] {
  const pending = incoming.map((invite) => {
    const missing = inviteTargetMissing(invite, planTrashNames, workspaceTrashNames);
    return {
      id: invite.id,
      author: invite.workspaceName,
      subject: inviteSubject(invite),
      preview: invitePreview(invite, missing, null),
      unread: true,
      missing,
      outcome: null,
      invite,
    };
  });
  const past = decisions.map((decision) => ({
    id: decision.invite.id,
    author: decision.invite.workspaceName,
    subject: inviteSubject(decision.invite),
    preview: invitePreview(decision.invite, false, decision.outcome),
    unread: false,
    missing: false,
    outcome: decision.outcome,
    invite: decision.invite,
  }));
  return [...pending, ...past];
}
